import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { OnboardingLayout } from '../Layout';
import { CountryPicker } from '@/components/domain/CountryPicker';
import { paths } from '@/routes/paths';

// Stand-alone full-screen variant of nationality picker (Figma 143:3153).
export function OnboardingNationalityPickerPage(): JSX.Element {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <OnboardingLayout back title={t('onboarding.passport.nationality')}>
      <CountryPicker onPick={() => navigate(paths.onboardingPassport, { replace: true })} />
    </OnboardingLayout>
  );
}
